/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { FormActionType } from "types/form.enum";
import AppointmentForm from "components/forms/AppointmentForm";
import { getNewAppointment } from "utils/model.utils";
import { useSelector } from "react-redux";
import { selectGeneralSettings } from "store/slices/generalSettingsSlice";

/**
 * Component for creating new appointment records.
 * Displays appointment form initialized with default values for new appointment creation.
 * 
 * @returns New appointment form component
 */
const NewAppointmentDataContent = () => {
  const generalSettings = useSelector(selectGeneralSettings);
  return <AppointmentForm model={getNewAppointment(undefined, generalSettings.defaultAppointmentDuration)} action={FormActionType.NEW} />;
};

export default NewAppointmentDataContent;
